import styled from 'styled-components'

import { FieldSet } from '@/components'
import { CheckBoxFormField } from '@/components/UberForm'

export const Checkbox = styled(CheckBoxFormField)`
	flex: 0;
`

export const FieldSetGap = styled(FieldSet)`
	margin-top: 20px;
`
